/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import { mapGetters } from 'vuex';

export default {
  name: 'quiz-history',
  components: {},
  props: [],
  data() {
    return {
      quizData:{
        courseId:''
      },
      coursesId:'',
      quizQuesDetails:'',
      quiezzesHistory:''
    }
  },
  computed: {
    ...mapGetters([
      'getQuizDetailsByIdDataState',
      'getQuizzesHistoryDataState'
    ]),
    getQuizQuesDetails() {
      this.quizQuesDetails = this.$store.getters.getQuizDetailsByIdDataState
      return this.quizQuesDetails
    },
    getQuizzesHistory(){
      this.quiezzesHistory = this.$store.getters.getQuizzesHistoryDataState.data
      return this.quiezzesHistory
    }
  },
  mounted() {
    this.getQuizzesHistory
    this.getQuizQuesDetails
    this.coursesId = this.$route.params.courseId;
    this.quizData.courseId = this.$route.params.quizId;
  },
  methods: {
  },
  beforeMount() {
  },
  watch: {
    getQuizQuesDetails() {
      return this.$store.getters.getQuizDetailsByIdDataState
    },
    getQuizzesHistory(){
      return this.$store.getters.getQuizzesHistoryDataState
    }
  },
}